import { toast } from "sonner";
import request from "@/lib/api/handler";

import { useAuth0 } from "@auth0/auth0-react";
import { useMutation } from "@tanstack/react-query";

export const useResendReferenceRequestEmail = (referenceId: string) => {
  const { getAccessTokenSilently } = useAuth0();

  const { mutate, isPending, error } = useMutation({
    mutationFn: async () => {
      const token = await getAccessTokenSilently();

      return request<undefined>({
        method: "POST",
        path: `/api/admin/references/${referenceId}/resend`,
        token,
      });
    },
    onSettled: (_, error) => {
      if (!error) {
        toast.success(`Reference request sent`);
      } else {
        toast.error(`Error sending a reference request`);
      }
    },
  });

  return {
    resendReferenceRequestEmail: mutate,
    isResendingReferenceRequestEmail: isPending,
    resendReferenceRequestEmailError: error,
  };
};
